import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TValueListLabel {
  label: string;
}

export interface IValueListLabel extends TValueListLabel {}

const ValueListLabel = Model(
  (model: TValueListLabel): IValueListLabel => {
    const _valueListLabel: TValueListLabel = Object.assign({}, model);

    let create = (valueListLabel: IValueListLabel): IValueListLabel => {
      let obj = ValidatableObject(valueListLabel);
      return obj;
    };

    let valueListLabel = {
      get label() {
        return _valueListLabel.label;
      }
    };

    return create(valueListLabel);
  }
);

export default ValueListLabel;
